export const ON_SIDEBAR_MODAL_BLUR = 'ON_SIDEBAR_MODAL_BLUR'
export const ON_SIDEBAR_MODAL_FOCUS = 'ON_SIDEBAR_MODAL_FOCUS'
export const SIZE_CHANGED = 'SIZE_CHANGED'
export const PLAY_VIDEO = 'PLAY_VIDEO'
export const CLOSE_VIDEO = 'CLOSE_VIDEO'
export const PLAY_HEADER_VIDEO = 'PLAY_HEADER_VIDEO'
export const PLAY_LESSON_VIDEO = 'PLAY_LESSON_VIDEO'
export const PAUSE_HEADER_VIDEO = 'PAUSE_HEADER_VIDEO'
export const PAUSE_LESSON_VIDEO = 'PAUSE_LESSON_VIDEO'
export const SET_USER_LOGGED_IN = 'SET_USER_LOGGED_IN'
